// extracted by mini-css-extract-plugin
export default {"item":"style_item__6OBHD"};